import { Button, withStyles } from '@material-ui/core';

const styles = (theme) => ({
  videoActionContainer: {
    display: 'flex',
    padding: 16,
    justifyContent: 'space-between'
  },
  navButtons: {
    '&>button:not(:last-child)': {
      marginRight: 16
    }
  },
  newTabButton: {
    textDecoration: 'underline'
  },
  commonButton: {
    '&$disabledButton': {
      color: theme.TextColor ?? '#000000',
      opacity : 0.7
    }
  },
  disabledButton: {}
});
const VideoNavigationActions = ({
  classes,
  closeButtonText,
  submitButtonText,
  onClose,
  onSubmit,
  showSubmitButton,
  videoURL,
  enableVideoInNewTab,
  isError
}) => {
  const openVideoInNewTab = () => {
    window.open(videoURL);
  };
  return (
    <div className={classes.videoActionContainer}>
      {enableVideoInNewTab && (
        <div>
          <Button
            variant="text"
            color="primary"
            onClick={openVideoInNewTab}
            className={classes.newTabButton}
            classes={{ root: classes.commonButton, disabled: classes.disabledButton }}
            disabled={isError}>
            Open video in new tab
          </Button>
        </div>
      )}
      <div className={classes.navButtons}>
        {showSubmitButton && (
          <Button
            variant="contained"
            color="primary"
            onClick={onSubmit}
            disabled={isError}
            classes={{ root: classes.commonButton, disabled: classes.disabledButton }}>
            {submitButtonText ?? 'Take Assessment'}
          </Button>
        )}
        <Button variant="outlined" color="primary" onClick={onClose}>
          {closeButtonText ?? 'Close'}
        </Button>
      </div>
    </div>
  );
};

export default withStyles(styles)(VideoNavigationActions);
